import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import DesignPlusBadge from "./DesignPlusBadge";
import { Toaster } from "../components/ui/sonner";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <DesignPlusBadge />
      <Toaster position="top-right" richColors />
    </div>
  );
}
